import { useState, useCallback } from 'react';

const CLE_SESSION = '3f_adherent_session';

function chargerSession() {
  try {
    const s = sessionStorage.getItem(CLE_SESSION);
    if (s) return JSON.parse(s);
  } catch (e) {}
  return null;
}

export function useAuth(config) {
  const [adherent, setAdherent] = useState(chargerSession);
  const [loading, setLoading] = useState(false);
  const [erreur, setErreur] = useState('');

  const connecter = useCallback(async (numeroAdherent, motDePasse) => {
    if (!config.url) {
      setErreur('Service non disponible. Contactez l\'administrateur.');
      return false;
    }
    setLoading(true);
    setErreur('');
    try {
      // URL du webhook auth = même base que le webhook chat
      const urlAuth = config.url.replace(/\/webhook(-test)?\/.*/, '/webhook/auth-3f-yvelines');

      const res = await fetch(urlAuth, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          action: 'login',
          numero_adherent: numeroAdherent.trim().toUpperCase(),
          mot_de_passe: motDePasse,
          source: '3F-Chatbot',
        }),
      });

      if (!res.ok) throw new Error('Erreur serveur ' + res.status);

      const data = await res.json();

      if (data.success && data.adherent) {
        const session = {
          ...data.adherent,
          connectedAt: new Date().toISOString(),
        };
        sessionStorage.setItem(CLE_SESSION, JSON.stringify(session));
        setAdherent(session);
        setLoading(false);
        return true;
      } else {
        setErreur(data.message || 'Numéro d\'adhérent ou mot de passe incorrect.');
        setLoading(false);
        return false;
      }
    } catch (e) {
      setErreur('Impossible de contacter le serveur. Vérifiez votre connexion.');
      setLoading(false);
      return false;
    }
  }, [config.url]);

  const deconnecter = useCallback(() => {
    sessionStorage.removeItem(CLE_SESSION);
    setAdherent(null);
    setErreur('');
  }, []);

  return { adherent, loading, erreur, connecter, deconnecter };
}
